import { render } from "./ForumListItem.vue?vue&type=template&id=1d6cc96f"
import script from "./ForumListItem.vue?vue&type=script&lang=js"
export * from "./ForumListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__